import Vue from 'vue'
import Router from 'vue-router'
import Layer1Index from '@/pages/layer1/index'
import FakeHome from '@/pages/layer1/fake-home'
import Home from '@/pages/layer1/home'
import Category from '@/pages/layer1/category'
import New from '@/pages/layer1/new'
import Shelf from '@/pages/layer1/shelf'
import User from '@/pages/layer1/user'
import Login from '@/pages/layer2/user/login'
import MobileBind from '@/pages/layer2/user/mobile-bind'
import ChangePassword from '@/pages/layer2/user/change-password'
import Purchase from '@/pages/layer2/user/purchase'
import PurchaseHistory from '@/pages/layer2/user/purchase-history'
import FindAccount from '@/pages/layer2/user/find-account'
import BooksIndex from '@/pages/layer2/books/index'
import LatestList from '@/pages/layer2/books/latest'
import RecommendList from '@/pages/layer2/books/recommend'
import ThreeDList from '@/pages/layer2/books/three-d'
import NewOnList from '@/pages/layer2/books/new-on'
import NewList from '@/pages/layer2/books/new'
import KkbgList from '@/pages/layer2/books/kkbg'
import RankedList from '@/pages/layer2/books/ranked'
import BookIndex from '@/pages/layer2/book/index'
import BookHome from '@/pages/layer2/book/home'
import BookRead from '@/pages/layer2/book/read'
import BookCatalog from '@/pages/layer2/book/catalog'
import PurchasePay from '@/pages/layer2/user/pay'
import BookSearch from '@/pages/layer1/search'

import Vod from '@/pages/layer1/vod'
import VodCategory from '@/pages/layer2/vod/category'
import VodDetail from '@/pages/layer2/vod/detail.vue'
import VodSearch from '@/pages/layer1/search-vod'
import VodShelf from '@/pages/layer1/shelf-vod'


Vue.use(Router);

Router.prototype.isBack = false;

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      redirect: '/index',
      name: 'index',
      component: Layer1Index,
      children: [
        {
          path: 'home',
          name: 'home',
          component: Home,
          meta: {
            type: 'none',
            number: 1,
            keepAlive: true
          }
        },
        {
          path: 'category',
          name: 'category',
          component: Category,
          meta: {
            type: 'none',
            number: 2,
            keepAlive: true
          }
        },
        //视频首页
        {
          path: 'vod',
          name: 'vod',
          component: Vod,
          meta: {
            type: 'none',
            number: 2,
            keepAlive: true
          }
        },
        //
        {
          path: 'vod/category',
          name: 'vod-category',
          component: VodCategory,
          meta: {
            type: 'none',
            number: 5
          }
        },
        {
          path: 'vod/detail',
          name: 'vod-detail',
          component: VodDetail,
          meta: {
            type: 'horizontal',
            number: 5
          }
        },
        {
          path: 'search-vod',
          name: 'search-vod',
          component: VodSearch,
          meta: {
            type: 'none',
            number: 6,
            topTitle: '搜索',
            keepAlive: true
          }
        },
        {
          path: 'shelf-vod',
          name: 'shelf-vod',
          component: VodShelf,
          meta: {
            type: 'none',
            number: 3,
            keepAlive: true
          }
        },


        {
          path: 'new',
          name: 'new',
          component: New,
          meta: {
            type: 'none',
            number: 2,
            keepAlive: true
          }
        },
        {
          path: 'shelf',
          name: 'shelf',
          component: Shelf,
          meta: {
            type: 'none',
            number: 3,
            keepAlive: true
          }
        },
        {
          path: 'user',
          name: 'user',
          component: User,
          meta: {
            type: 'none',
            number: 4
          }
        },
        {
          path: 'purchase',
          name: 'purchase',
          component: Purchase,
          meta: {
            type: 'horizontal',
            number: 5
          }
        },
        {
          path: 'search',
          name: 'home-search',
          component: BookSearch,
          meta: {
            type: 'horizontal',
            number: 6,
            topTitle: '搜索',
            keepAlive: true
          }
        }
      ]
    },
    {
      path: '/index',
      name: 'fake-home',
      component: FakeHome,
      meta: {
        type: 'none',
        number: 6
      }
    },
    // 添加后缀支持，使cdn能根据后缀缓存
    {
      path: '/home.html',
      redirect: '/home'
    },
    {
      path: '/home',
      name: 'home-list-index',
      component: BooksIndex,
      children: [
        {
          path: 'recommend',
          name: 'home-recommend',
          component: RecommendList,
          meta: {
            type: 'horizontal',
            number: 6,
            topTitle: '露露推荐',
            keepAlive: true
          }
        },
        {
          path: 'three-d',
          name: 'three-d',
          component: ThreeDList,
          meta: {
            type: 'horizontal',
            number: 6,
            topTitle: '真空出境',
            keepAlive: true
          }
        },
        {
          path: 'kkbg',
          name: 'home-kkbg',
          component: KkbgList,
          meta: {
            type: 'horizontal',
            number: 6,
            topTitle: '露露重磅',
            keepAlive: true
          }
        },
        {
          path: 'new-on',
          name: 'new-on',
          component: NewOnList,
          meta: {
            type: 'horizontal',
            number: 6,
            topTitle: '新书速递',
            keepAlive: true
          }
        },
        {
          path: 'new',
          name: 'new',
          component: NewList,
          meta: {
            type: 'none',
            number: 6,
            topTitle: '更新',
            keepAlive: true
          }
        },
        {
          path: 'ranked',
          name: 'home-ranked',
          component: RankedList,
          meta: {
            type: 'horizontal',
            number: 6,
            topTitle: '人气榜单',
            keepAlive: true
          }
        },
        {
          path: 'latest',
          name: 'home-latest',
          component: LatestList,
          meta: {
            type: 'horizontal',
            number: 6,
            topTitle: '最新上架',
            keepAlive: true
          }
        }
      ]
    },
    {
      path: '/book',
      name: 'book',
      component: BookIndex,
      children: [
        {
          path: ':id',
          name: 'book-home',
          component: BookHome,
          meta: {
            type: 'vertical',
            number: 1,
            keepAlive: true
          }
        },
        {
          path: ':id/catalog',
          name: 'book-catalog',
          component: BookCatalog,
          meta: {
            type: 'vertical',
            number: 2,
            keepAlive: true
          }
        },
        {
          path: 'read/:id/:number',
          name: 'book-read',
          component: BookRead,
          meta: {
            type: 'vertical',
            number: 3
          }
        }
      ]
    },
    {
      path: '/user/login',
      name: 'user-login',
      component: Login,
      meta: {
        type: 'horizontal',
        number: 5
      }
    },
    {
      path: '/user/bind',
      name: 'user-bind',
      component: MobileBind,
      meta: {
        type: 'horizontal',
        number: 5
      }
    },
    {
      path: '/user/password',
      name: 'user-password',
      component: ChangePassword,
      meta: {
        type: 'horizontal',
        number: 5
      }
    },
    {
      path: '/user/purchase/history',
      name: 'user-purchase-history',
      component: PurchaseHistory,
      meta: {
        type: 'horizontal',
        number: 5
      }
    },
    {
      path: '/user/find-account',
      name: 'find-account',
      component: FindAccount,
      meta: {
        type: 'horizontal',
        number: 5
      }
    },
    {
      path: '/user/purchase/pay',
      name: 'user-purchase-pay',
      component: PurchasePay,
      meta: {
        type: 'horizontal',
        number: 5
      }
    },

    {
      path: '*',
      name: 'other',
      redirect: '/'
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js